import { buildMeta } from "../lib/seo.js";
import { SITE } from "../lib/site.js";

export function meta() {
  return buildMeta({
    title: "Accessibility Statement",
    description:
      "RDV Systems' commitment to an accessible website, the standards we follow, and how to report a problem.",
    path: "/accessibility",
  });
}

export default function Accessibility() {
  return (
    <section className="section">
      <div className="container">
        <h1>Accessibility Statement</h1>
        <p className="lead">
          RDV Systems wants everyone to be able to use this website. This statement describes what
          we do, where we fall short, and how to reach us.
        </p>
        <div className="prose">
          <h2>Our commitment</h2>
          <p>
            RDV Systems aims to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level
            AA on www.rdvsystems.com.
          </p>
          <h2>What we have done</h2>
          <ul>
            <li>Keyboard navigation for every menu and form.</li>
            <li>Visible focus indicators.</li>
            <li>A skip link.</li>
            <li>Text alternatives for images.</li>
            <li>Captions or text descriptions for video where available.</li>
            <li>
              Adjustable text size, high-contrast mode and reduced motion through the accessibility
              panel (the floating button on every page).
            </li>
            <li>Semantic headings and landmarks.</li>
            <li>Color contrast that meets AA.</li>
          </ul>
          <h2>Known limitations</h2>
          <ul>
            <li>
              Embedded third-party video players (Vimeo, YouTube) have their own controls and
              captions.
            </li>
            <li>PDF downloads produced before 2026 may not be tagged.</li>
            <li>
              The interactive 3D models in the 3D Visualization product are demonstrated by video on
              this site because the models themselves are not screen-reader accessible.
            </li>
          </ul>
          <h2>Feedback and contact</h2>
          <p>
            If you find an accessibility barrier on this website, email{" "}
            <a href={`mailto:${SITE.email}`}>{SITE.email}</a> or call{" "}
            <a href={SITE.phoneHref}>{SITE.phone}</a>. We aim to respond within five business days.
          </p>
          <h2>Assessment</h2>
          <p>
            We self-evaluate this website with automated tools (axe, Lighthouse) and manual keyboard
            and screen-reader testing (NVDA, VoiceOver).
          </p>
          <p>Statement date: 2026-09-16.</p>
        </div>
      </div>
    </section>
  );
}
